module.exports = __webpack_public_path__ + "img/icon_dot_grey.ae5b2902.svg";